const WEB_VERSION = '1.0.2.3'

const ENV: IEnv = (global as any).ENV || 'debug'

// GMAP API KEYS
const GMAP_APIKEY_CARDIWEB = 'AIzaSyDV9omaJTY9Rktm1y1tvOy_kk2HL21WRw0'
const GMAP_APIKEY_GRDF = 'AIzaSyBbBqdkq0KtKBWMgo56qAoMZZ4hB4mfxyk'

// OKTA CLIENT IDS
const OKTA_CLIENT_ID_INT = '0oa63f6waup4LB0so0i7'
const OKTA_CLIENT_ID_RE7 = '0oa63f0kmxBwfYoG10i7'
const OKTA_CLIENT_ID_PPD = '0oa63f0o9zYpABKKw0i7'
const OKTA_CLIENT_ID_PROD = '0oa7h0plrngnRFjqo0i7'

// OKTA BASE URL
const OKTA_BASE_URL_INT = 'https://grdfrecette.okta-emea.com/oauth2/aus2wmvcy0nMn4Ckr0i7/v1'
const OKTA_BASE_URL_RE7 = 'https://grdfrecette.okta-emea.com/oauth2/aus2wmvcy0nMn4Ckr0i7/v1'
const OKTA_BASE_URL_PPD = 'https://grdfrecette.okta-emea.com/oauth2/aus2wmvcy0nMn4Ckr0i7/v1'
const OKTA_BASE_URL_PROD = 'https://grdf.okta-emea.com/oauth2/aus3k8giyen6PW0700i7/v1'

// OKTA EXT CLIENT IDS
const EXTERNAL_OKTA_CLIENT_ID_INT = '0oa9lntuzai81vQLq0i7'
const EXTERNAL_OKTA_CLIENT_ID_RE7 = '0oa9lo026hHFeaiSU0i7'
const EXTERNAL_OKTA_CLIENT_ID_PPD = '0oa9lo0yjawOKaXwp0i7'
const EXTERNAL_OKTA_CLIENT_ID_PROD = '0oaacn0xi9IS6Zdsd0i7'

// OKTA EXT BASE URL
const EXTERNAL_OKTA_BASE_URL_INT = 'https://grdfrecette.okta-emea.com/oauth2/aus2wmvcy0nMn4Ckr0i7/v1'
const EXTERNAL_OKTA_BASE_URL_RE7 = 'https://grdfrecette.okta-emea.com/oauth2/aus2wmvcy0nMn4Ckr0i7/v1'
const EXTERNAL_OKTA_BASE_URL_PPD = 'https://grdfrecette.okta-emea.com/oauth2/aus2wmvcy0nMn4Ckr0i7/v1'
const EXTERNAL_OKTA_BASE_URL_PROD = 'https://grdf.okta-emea.com/oauth2/aus3k8giyen6PW0700i7/v1'

// OKTA SCOPES
const INTERNAL_SCOPES = ['openid', 'profile', 'email', 'services.ckcc.admin']
const EXTERNAL_SCOPES = ['openid', 'profile', 'email', 'offline_access', 'services.ckcc.admin']

// OKTA REDIRECT URL
const logoutRedirectUrl = '/logout'
const redirectUrl = '/login/okta/callback'

const EnvConfig = (env: IEnv): IEnvConfig => {
  switch (env) {
    case 'debug':
      return {
        API_VERSION: '/services/ckcc/v1',
        logLevel: 'debug',
        GMAP_APIKEY: GMAP_APIKEY_CARDIWEB,
        AUTH_CONFIG: {
          INTERNAL: {
            SERVER_PREFIX: 'https://ckcc.int.cardiweb.com',
            loginUrl: 'http://localhost:3000',
            authorizationEndpoint: OKTA_BASE_URL_INT + '/authorize',
            tokenEndpoint: OKTA_BASE_URL_INT + '/token',
            logoutEndpoint: OKTA_BASE_URL_INT + '/logout',
            clientId: OKTA_CLIENT_ID_INT,
            redirectUrl,
            logoutRedirectUrl,
            scopes: INTERNAL_SCOPES,
          },
          EXTERNAL: {
            SERVER_PREFIX: 'https://ckcc.int.cardiweb.com',
            loginUrl: 'http://localhost:3000',
            authorizationEndpoint: EXTERNAL_OKTA_BASE_URL_INT + '/authorize',
            tokenEndpoint: EXTERNAL_OKTA_BASE_URL_INT + '/token',
            logoutEndpoint: EXTERNAL_OKTA_BASE_URL_INT + '/logout',
            clientId: EXTERNAL_OKTA_CLIENT_ID_INT,
            redirectUrl,
            logoutRedirectUrl,
            scopes: EXTERNAL_SCOPES,
          },
        },
      }
    case 'intma':
      return {
        API_VERSION: '/services/ckcc/v1',
        logLevel: 'info',
        GMAP_APIKEY: GMAP_APIKEY_CARDIWEB,
        AUTH_CONFIG: {
          INTERNAL: {
            SERVER_PREFIX: 'https://ckcc.int.cardiweb.com',
            loginUrl: 'https://ckcc-web.int.cardiweb.com',
            authorizationEndpoint: OKTA_BASE_URL_INT + '/authorize',
            tokenEndpoint: OKTA_BASE_URL_INT + '/token',
            logoutEndpoint: OKTA_BASE_URL_INT + '/logout',
            clientId: OKTA_CLIENT_ID_INT,
            redirectUrl,
            logoutRedirectUrl,
            scopes: INTERNAL_SCOPES,
          },
          EXTERNAL: {
            SERVER_PREFIX: 'https://ckcc.int.cardiweb.com',
            loginUrl: 'https://ckcc-web.int.cardiweb.com',
            authorizationEndpoint: EXTERNAL_OKTA_BASE_URL_INT + '/authorize',
            tokenEndpoint: EXTERNAL_OKTA_BASE_URL_INT + '/token',
            logoutEndpoint: EXTERNAL_OKTA_BASE_URL_INT + '/logout',
            clientId: EXTERNAL_OKTA_CLIENT_ID_INT,
            redirectUrl,
            logoutRedirectUrl,
            scopes: EXTERNAL_SCOPES,
          },
        },
      }
    case 're7':
      return {
        API_VERSION: '/services/ckcc/v1',
        logLevel: 'info',
        GMAP_APIKEY: GMAP_APIKEY_GRDF,
        AUTH_CONFIG: {
          INTERNAL: {
            SERVER_PREFIX: 'https://rec.private-api.grdf.fr',
            loginUrl: 'https://rec-ckcc.grdf.net',
            authorizationEndpoint: OKTA_BASE_URL_RE7 + '/authorize',
            tokenEndpoint: OKTA_BASE_URL_RE7 + '/token',
            logoutEndpoint: OKTA_BASE_URL_RE7 + '/logout',
            clientId: OKTA_CLIENT_ID_RE7,
            redirectUrl,
            logoutRedirectUrl,
            scopes: INTERNAL_SCOPES,
          },
          EXTERNAL: {
            SERVER_PREFIX: 'https://rec.private-api.grdf.fr',
            loginUrl: 'https://rec-ckcc-partenaires.grdf.net',
            authorizationEndpoint: EXTERNAL_OKTA_BASE_URL_RE7 + '/authorize',
            tokenEndpoint: EXTERNAL_OKTA_BASE_URL_RE7 + '/token',
            logoutEndpoint: EXTERNAL_OKTA_BASE_URL_RE7 + '/logout',
            clientId: EXTERNAL_OKTA_CLIENT_ID_RE7,
            redirectUrl,
            logoutRedirectUrl,
            scopes: EXTERNAL_SCOPES,
          },
        },
      }
    case 'preprod':
      return {
        API_VERSION: '/services/ckcc/v1',
        logLevel: 'warn',
        GMAP_APIKEY: GMAP_APIKEY_GRDF,
        AUTH_CONFIG: {
          INTERNAL: {
            SERVER_PREFIX: 'https://pprd.private-api.grdf.fr',
            loginUrl: 'https://pp-ckcc.grdf.fr',
            authorizationEndpoint: OKTA_BASE_URL_PPD + '/authorize',
            tokenEndpoint: OKTA_BASE_URL_PPD + '/token',
            logoutEndpoint: OKTA_BASE_URL_PPD + '/logout',
            clientId: OKTA_CLIENT_ID_PPD,
            redirectUrl,
            logoutRedirectUrl,
            scopes: INTERNAL_SCOPES,
          },
          EXTERNAL: {
            SERVER_PREFIX: 'https://pprd.private-api.grdf.fr',
            loginUrl: 'https://pp-ckcc-partenaires.grdf.fr',
            authorizationEndpoint: EXTERNAL_OKTA_BASE_URL_PPD + '/authorize',
            tokenEndpoint: EXTERNAL_OKTA_BASE_URL_PPD + '/token',
            logoutEndpoint: EXTERNAL_OKTA_BASE_URL_PPD + '/logout',
            clientId: EXTERNAL_OKTA_CLIENT_ID_PPD,
            redirectUrl,
            logoutRedirectUrl,
            scopes: EXTERNAL_SCOPES,
          },
        },
      }
    case 'release':
      return {
        API_VERSION: '/services/ckcc/v1',
        logLevel: 'warn',
        GMAP_APIKEY: GMAP_APIKEY_GRDF,
        AUTH_CONFIG: {
          INTERNAL: {
            SERVER_PREFIX: 'https://private-api.grdf.fr',
            loginUrl: 'https://ckcc.grdf.fr',
            authorizationEndpoint: OKTA_BASE_URL_PROD + '/authorize',
            tokenEndpoint: OKTA_BASE_URL_PROD + '/token',
            logoutEndpoint: OKTA_BASE_URL_PROD + '/logout',
            clientId: OKTA_CLIENT_ID_PROD,
            redirectUrl,
            logoutRedirectUrl,
            scopes: INTERNAL_SCOPES,
          },
          EXTERNAL: {
            SERVER_PREFIX: 'https://private-api.grdf.fr',
            loginUrl: 'https://ckcc-partenaires.grdf.fr',
            authorizationEndpoint: EXTERNAL_OKTA_BASE_URL_PROD + '/authorize',
            tokenEndpoint: EXTERNAL_OKTA_BASE_URL_PROD + '/token',
            logoutEndpoint: EXTERNAL_OKTA_BASE_URL_PROD + '/logout',
            clientId: EXTERNAL_OKTA_CLIENT_ID_PROD,
            redirectUrl,
            logoutRedirectUrl,
            scopes: EXTERNAL_SCOPES,
          },
        },
      }
  }
}

const config: IConfig = {
  env: ENV,
  ...EnvConfig(ENV),
  constants: {},
  ws: {
    user: {
      login: '/user/me',
      cgus: '/user/me/cgu',
    },
    business: {
      get: '/businesses/',
      list: '/businesses/search',
      details: '/businesses/details/',
      comment: '/businesses/comment/',
      map: '/businesses/map',
    },
    declaration: {
      edit: '/declarations/',
      releaseBreakpoint: '/declarations/{idDeclaration}/breakpoint/release',
      pictures: {
        getPicture: '/declarations/pictures/{pictureId}',
      },
    },
    company: {
      list: '/companies',
      listCompanyGroups: '/companyGroups',
    },
    responsible: {
      list: '/responsibles',
    },
    step: {
      list: '/steps',
    },
    orphan: {
      list: '/orphans/search',
      get: '/orphans/',
      delete: '/orphans/',
      affect: '/orphans/',
    },
    admin: {
      list: {
        regions: '/admin/regions',
        companies: '/admin/companies',
        internals: '/admin/internals/simplified',
        externals: '/admin/externals/simplified',
        businesses: '/admin/businesses/simplified',
      },
      internal: {
        list: '/admin/internals',
        edit: '/admin/internals/',
        add: '/admin/internals',
        delete: '/admin/internals/',
      },
      external: {
        list: '/admin/externals',
        edit: '/admin/externals/',
        add: '/admin/externals',
        delete: '/admin/externals/',
      },
      company: {
        list: '/admin/companies',
        edit: '/admin/companies/',
        get: '/admin/companies/',
        add: '/admin/companies',
        delete: '/admin/companies/',
        listBusinesses: '/admin/companies/{idCompany}/businesses',
        getUsers: '/admin/companies/{idCompany}/users',
      },
      companyGroup: {
        get: '/admin/companyGroups',
        delete: '/admin/companyGroup/',
        add: '/admin/companyGroup',
        edit: '/admin/companyGroup/',
      },
      business: {
        list: '/admin/businesses',
        edit: '/admin/businesses/',
        board: '/admin/businesses/board',
        export: '/admin/businesses/board/export',
        import: '/admin/businesses/companies/import',
      },
      export: {
        users: '/admin/users/export',
        declarations: '/admin/declarations/export',
        stats: '/admin/stats/simplified',
      },
      import: {
        internals: {
          add: '/admin/internals/import',
          edit: '/admin/internals/import',
          delete: '/admin/internals/import',
        },
        externals: {
          add: '/admin/externals/import',
          edit: '/admin/externals/import',
          delete: '/admin/externals/import',
        },
      },
    },
  },
}

export default config
export { WEB_VERSION }
